module.exports = __webpack_public_path__ + "img/a36aede.svg";